import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './StartButton.less'

interface StartButtonProps {
  onStart: () => void
  tooltipText?: string
  className?: string
  disabled?: boolean
}

export const StartButton: React.FC<StartButtonProps> = ({
  onStart,
  tooltipText = 'Start with this title',
  className = '',
  disabled = false
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    if (!disabled) {
      onStart()
    }
  }

  return (
    <div className={`start-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="start-button"
        onMouseDown={handleClick}
        aria-label="Start"
        title={tooltipText}
        disabled={disabled}
      >
        <Icon
          name={IconName.Play}
          className="start-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
